import React from 'react'
import Slider from 'react-slick'

import './homeSlider.scss'

const HomeSlider = ({ items }) => {
	const settings = {
		draggable: false,
		swipeToSlide: false,
		swipe: false,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		autoplaySpeed: 5000,
		lazyLoad: 'ondemand',
	}

	return (
		<div className={`homeSlider`}>
			<Slider {...settings}>
				{items.map((item) => (
					<li className="homeSlider_item" key={item.id}>
						<p className="homeSlider_text">{item.text}</p>
						<div className="homeSlider_img">
							<div>{item.img}</div>
						</div>
					</li>
				))}
			</Slider>
		</div>
	)
}

export default HomeSlider
